import { togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"

// Login Redux States
import {
  getTimeLogByDate,
  get_WorkProjectList,
  post_ClientViewScreenList,
  post_WorkProjectScreenList,
  postMoviIdHHoursTimeLog,
  postAddManualEntryTimeLog,
  postAddChangeStatusTimelog,
  gettMoviIdHHoursFromId,
  getActivityLogByDate,
  flag_timelog_invalid,
} from "helpers/backend_helper"
import {
  clientScreenSuccess,
  getallprojectListsError,
  getallprojectListsSuccess,
  storeTimeLogByDate,
  workScreenError,
  workScreenSuccess,
  storeActivityLogByDate,
} from "./action"
import {
  CLIENT_SCREEN,
  GET_TIMELOGBYDATE,
  PROJECT_LISTS,
  WORK_SCREEN,
  MOVE_ID_HOURS_TIMELOG,
  ADD_MANUAL_ENTRY_TIMELOG,
  MOVE_ID_HOURS_FROMID,
  CHANGE_STATUS_TIMELOG,
  GET_ACTIVITYLOGBYDATE,
  FLAG_TIMELOG_INVALID,
} from "./actionType"

function* getProjectsList({ payload: timesheet }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_WorkProjectList, timesheet)
    if (response.status === "Success") {
      yield put(getallprojectListsSuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(getallprojectListsError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getallprojectListsError(error))
    yield put(togglePageLoader(false))
  }
}

function* getscreenVerified({ payload: screens }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_WorkProjectScreenList, screens)
    if (response.status === "Success") {
      yield put(workScreenSuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(workScreenError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(workScreenError(error))
    yield put(togglePageLoader(false))
  }
}
//client screen view 
function* getclientscreen({ payload: screens }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_ClientViewScreenList, screens)
    if (response.status === "Success") {
      yield put(clientScreenSuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(clientScreenError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(workScreenError(error))
    yield put(togglePageLoader(false))
  }
}

//client screen view 
function* timeLogByDate({ payload }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getTimeLogByDate, payload)
    if (response.status === "Success") {
      yield put(storeTimeLogByDate(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(storeTimeLogByDate([]))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(storeTimeLogByDate([]))
    yield put(togglePageLoader(false))
  }
}

function* moveHours({ payload, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(postMoviIdHHoursTimeLog, payload)
    if (response.status === "Success") {
      callback(response)
      // yield put(storeTimeLogByDate(response.data))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      // yield put(storeTimeLogByDate([]))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    console.log(error, 'error')
    // yield put(storeTimeLogByDate([]))
    toast.error(error.message)
    yield put(togglePageLoader(false))
  }
}

function* addManualEntry({ payload, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(postAddManualEntryTimeLog, payload)
    if (response.status === "Success") {
      callback(response)
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    console.log(error, 'error')
    toast.error(error.message)
    yield put(togglePageLoader(false))
  }
}

function* moveHoursFromID({ payload, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(gettMoviIdHHoursFromId, payload)
    if (response.status === "Success") {
      callback(response)
      yield put(togglePageLoader(false))
    } else {
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    console.log(error, 'error')
    toast.error(error.message)
    yield put(togglePageLoader(false))
  }
}

function* addChangeStatus({ payload, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(postAddChangeStatusTimelog, payload)
    if (response.status === "Success") {
      callback(response)
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      toast.success(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error.message)
    yield put(togglePageLoader(false))
  }
}

function* flagTimeLogInvalidSaga({ payload, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(flag_timelog_invalid, payload)
    if (response.statusCode === 200 || response.status === "Success") {
      toast.success(response.message)
      yield put(togglePageLoader(false))
      if (callback) callback(response)
    } else {
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error.message)
    yield put(togglePageLoader(false))
  }
}

//activity log by date
function* activityLogByDate({ payload }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getActivityLogByDate, payload)
    if (response.status === "Success") {
      yield put(storeActivityLogByDate(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(storeActivityLogByDate([]))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(storeActivityLogByDate([]))
    yield put(togglePageLoader(false))
  }
}

function* createTeamsage() {
  yield takeEvery(PROJECT_LISTS, getProjectsList)
  yield takeEvery(WORK_SCREEN, getscreenVerified)
  yield takeEvery(CLIENT_SCREEN, getclientscreen)
  yield takeEvery(GET_TIMELOGBYDATE, timeLogByDate)
  yield takeEvery(MOVE_ID_HOURS_TIMELOG, moveHours)
  yield takeEvery(ADD_MANUAL_ENTRY_TIMELOG, addManualEntry)
  yield takeEvery(CHANGE_STATUS_TIMELOG,addChangeStatus)
  yield takeEvery(MOVE_ID_HOURS_FROMID, moveHoursFromID)
  yield takeEvery(FLAG_TIMELOG_INVALID, flagTimeLogInvalidSaga)
  yield takeEvery(GET_ACTIVITYLOGBYDATE, activityLogByDate)
}

export default createTeamsage
